<template>
  <div>
    <el-table
      class="banner-table"
      :data="bannerList"
      :row-key="() => Math.random()"
    >
      <el-table-column prop="__platform" label="平台"> </el-table-column>
      <!-- <el-table-column
        prop="__positionType"
        label="广告位置">
      </el-table-column> -->
      <el-table-column prop="__language" label="语言类型"> </el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          {{
            (
              bannerTypes.find(item => Number(item.type) === scope.row.type) ||
              {}
            ).message
          }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题"> </el-table-column>
      <el-table-column label="图片" label-width="200">
        <template slot-scope="scope">
          <image-wrapper
            :src="scope.row.imageUrl"
            width="200px"
          ></image-wrapper>
        </template>
      </el-table-column>
      <el-table-column label="跳转地址">
        <template slot-scope="scope">
          <a :href="scope.row.linkUrl" target="_blank">
            {{ scope.row.linkUrl }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleUpdate(scope.row.id)"
          ></el-button>
          <el-button
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleRemove(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <banner-detail :value="bannerId" @refresh="refreshList"></banner-detail>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import ImageWrapper from 'components/image';
import BannerDetail from '../detail';
import SortableMixin from 'mixins/SortableMixin';

export default {
  name: 'BannerList',
  mixins: [SortableMixin],
  data() {
    return {
      bannerId: null,
      sortable: '.banner-table'
    };
  },
  components: {
    ImageWrapper,
    BannerDetail
  },
  computed: {
    ...mapState('appFunctionalPageSetting', ['bannerTypes']),
    ...mapGetters('appFunctionalPageSetting', ['bannerList'])
  },
  methods: {
    ...mapMutations('appFunctionalPageSetting', ['toggleDetailDialogVisible']),
    ...mapActions('appFunctionalPageSetting', ['list', 'remove', 'updateSort']),
    handleUpdate(id) {
      this.bannerId = id;
      this.toggleDetailDialogVisible(true);
    },
    handleRemove(id) {
      this.$confirm('确认删除此广告吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.remove(id).then(() => {
            this.$message.success('删除成功！');
            this.$emit('refresh');
          });
        })
        .catch(() => {});
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt;

      if (oldIndex !== newIndex) {
        const banner = this.bannerList[oldIndex];

        this.updateSort({
          id: banner.id,
          language: banner.language,
          platform: banner.platform,
          type: banner.type,
          orderNo: newIndex + 1
        }).then(() => {
          this.$message.success('更新成功！');
          this.$emit('refresh');
        });
      }
    },
    refreshList() {
      this.$emit('refresh');
    }
  }
};
</script>

<style lang="less" scoped>
.image-container{
  padding: 7px;
}
</style>
